// @mui
import { Box, Button, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.bilalsadasub';

export default function NavbarDocs() {
  return (
    <Stack sx={{ px: 2.5, pb: 3, pt: 1 }}>
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          p: 2.5,
          borderRadius: 3,
          textAlign: 'center',
          background: 'linear-gradient(150deg, #1C1C1E 0%, #131313 100%)',
          border: '1px solid rgba(248,199,54,0.22)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -28,
            right: -28,
            width: 90,
            height: 90,
            borderRadius: '50%',
            background: 'rgba(248,199,54,0.22)',
            filter: 'blur(28px)',
          }}
        />
        <Box
          component="img"
          src="/logo_icon.webp"
          alt="Bilalsadasub"
          sx={{ position: 'relative', width: 46, height: 46, mx: 'auto', mb: 1.25, borderRadius: 1.5 }}
        />
        <Typography sx={{ position: 'relative', fontWeight: 800, fontSize: '0.92rem', color: '#fff' }}>
          Get more on the app
        </Typography>
        <Typography
          sx={{ position: 'relative', fontSize: '0.74rem', color: 'rgba(255,255,255,0.6)', mt: 0.5, mb: 1.75 }}
        >
          Faster payments, right in your pocket.
        </Typography>
        <Button
          fullWidth
          size="small"
          variant="contained"
          href={PLAY_STORE}
          target="_blank"
          rel="noopener"
          sx={{ position: 'relative', fontWeight: 700, borderRadius: 2 }}
        >
          Download the app
        </Button>
      </Box>
    </Stack>
  );
}
